export function debug(msg: string) {
    console.log(`%c[DEBUG] %c${msg}`, 'color: #006dff;', '')
}
